import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import * as listActions from '../list/actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';
import store from '../../../../store';

function* deleteRegularusersGroup({ payload: { id, onSuccess } }) {
  const { getState, dispatch } = store;

  try {
    const { data } = yield call(fetch, { api: api.modifiers.regularusers.remove, id });

    dispatch(listActions.getRegularusersGroupsRequest({ curr_page: getState().getRegularusersGroups.curr_page }));

    onSuccess && onSuccess();
    yield put(actions.deleteRegularusersGroupDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.deleteRegularusersGroupFailed,
      endpoint: api.modifiers.regularusers.remove.url
    });
  }
}

export const deleteRegularusersGroupSaga = takeEvery(types.DELETE_REGULARUSERS_GROUP_REQUEST, deleteRegularusersGroup);